import React from 'react';
import { useVehicles } from 'services/useVehicles';
import { useSelectedProject } from 'services/useSelectedProject';
import { VehicleSelector as VehicleSelectorView } from 'components/views/organisms/VehicleSelector';
import { useNavigate } from 'react-router';
import { useSelectedEnvironment } from 'services/useSelectedEnvironment';
import { useEnvironments } from 'services/useEnvironments';
import { useScopeCheck } from 'services/useScope';
import { CautionText } from 'components/views/atoms/CautionText';

export type VehicleSelectorProps = {
    title: string;
}

const VehicleSelectorImpl = (props: VehicleSelectorProps) => {
    const { title } = props;

    const project = useSelectedProject();
    const environments = useEnvironments(project?.id);
    const environment = useSelectedEnvironment(environments);
    const vehicles = useVehicles(project?.id, environment?.id);
    const navigate = useNavigate();

    return (
        <VehicleSelectorView title={title} vehicles={vehicles} onSelect={vehicle => navigate(vehicle.id)} />
    );
};

export function VehicleSelector(props: VehicleSelectorProps) {
    const isVehicleListAllowed = useScopeCheck('getVehiclesScope');

    if (isVehicleListAllowed === undefined) return <></>;

    return (
        isVehicleListAllowed
            ? <VehicleSelectorImpl {...props} />
            : <CautionText text={'You don\'t have permission to view the vehicles'} />
    );
}
